<template>
  <b-modal
      id="container"
      v-model="errorModal"
      style="z-index: 100000"
      title="¡Chanfle! Algo pasó..."
      @close="onModalClose()"
      hide-footer
      centered
      noCloseOnBackdrop
      data-cy="api-error-modal"
  >
    <div>
      <div
          class="container"
          data-cy="api-error-modal-container"
      >
        <div class="row">
          <div class="col-sm-12 col-md-3">
            <vs-chip class="h5">
              <vs-avatar
                  size="30px"
                  color="#7367f0"
                  icon="sentiment_dissatisfied"
              />
              Cód: <b class="ml-1">{{ apiError.codigo }}</b>
            </vs-chip>
          </div>
          <div class="col-sm-12 col-md-9">
            <vs-list-item
                icon="error_outline"
                v-for="(error, index) in apiError.errores"
                :key="index"
                :title="error"
                data-cy="api-error-modal-container-error"
            />
          </div>
          <div class="col-12 my-4">
            <div></div>
            <vs-list>
              <vs-list-header
                  :title="apiError.mensaje"
                  data-cy="api-error-modal-container-mensaje"
              />
              <vs-list-item
                  style="cursor: pointer;"
                  @click.native="copyToClipboard"
                  :icon="copyIcon"
                  :class="{ 'text-success': wasCopied }"
                  :title="apiError.seguimientoId"
                  subtitle="Click para copiar automáticamente"
              />
            </vs-list>
          </div>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-auto">
          <b-button
              @click="copyToClipboard"
              variant="outline-primary"
          >
            Copiar
          </b-button>
          <b-button
              variant="outline-secondary"
              class="ml-3"
              @click="clearError"
          >
            Cerrar
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      errorModal: false,
      wasCopied: false,
      copyIcon: 'content_copy'
    };
  },
  computed: {
    ...mapGetters([
      'apiError'
    ])
  },
  watch: {
    apiError(newValue) {
      if (Object.keys(newValue).length) {
        this.errorModal = true;
      }
    },
    wasCopied(val) {
      if (val) {
        this.copyIcon = 'assignment_turned_in';
      } else {
        this.copyIcon = 'content_copy';
      }
    }

  },
  created() {
    this.setApiError({});
    this.errorModal = false;
  },
  methods: {
    ...mapActions([
      'setApiError'
    ]),
    onModalClose() {
      this.setApiError({});
      this.errorModal = false;
      this.wasCopied = false;
    },
    clearError() {
      this.errorModal = false;
      this.setApiError({});
      this.wasCopied = false;
    },
    copyToClipboard() {
      navigator.clipboard.writeText(this.apiError.seguimientoId).then(() => {
        this.wasCopied = true;
      });
    }
  }
};

</script>
